import React, { useEffect, useRef, useState } from "react";
import "./addTrail.scss";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import HookForm from "../../components/hookForm/hookForm";
import { Controller } from "react-hook-form";
import FileUpload from "../../components/fileUpload/fileUpload";
import TextField from "../../components/textField/textField";
import { Label } from "reactstrap";
import CustomSelect from "../../components/customSelect/customSelect";
import CustomButton from "../../components/customButton/customButton";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/features/toast/toastSlice";
import Constant from "../../util/constant";
import axios from "axios";
import {
  TRAILS_ADD,
  TRAILS_EDIT,
  SUGGESTED_TRAILS_STATUS,
  UPLOAD_GPX,
} from "../../api/endPoint";
import {
  batchUploadToCloudinary,
  getCloudinaryFeaturedImageUrl,
  getCloudinaryOtherImageUrl,
  uploadPhoto,
  base64ToFile,
  cleanFileName,
  uploadGpxFile,
} from "../../util/cloudinaryUpload";
import { Helmet } from "react-helmet";

const AddTrail: React.FC = () => {
  let triggerRef = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const trailData = location?.state?.trailData || {};
  const { id } = useParams(); // Get trail ID from URL for edit mode
  const isEditMode = !!id;
  console.log("isEditMode :::", isEditMode);

  // console.log('location11>>', location);

  const [loading, setLoading] = useState(false);
  const [wordCount, setWordCount] = useState(
    trailData?.description
      ? trailData.description.trim().split(/\s+/).length
      : 0
  );
  const [fileName, setFileName] = useState<string>("");
  const [otherFileNames, setOtherFileNames] = useState<string[]>([]);

  useEffect(() => {
    setWordCount(
      trailData?.description
        ? trailData?.description?.trim()?.split(/\s+/)?.length
        : 0
    );
  }, [trailData?.description]);

  const [editFeaturedImage, setEditFeaturedImage] = useState<boolean>(false);
  const [editOtherImage, setEditOtherImage] = useState<boolean>(false);

  const [mediaFiles, setMediaFiles] = useState<any>(
    location?.state?.mode === "edit" && trailData?.featured_image
      ? trailData.featured_image
      : ""
  );
  const [mediaPreviewShow, setMediaPreviewShow] = useState<any>(
    location?.state?.mode === "edit" && trailData?.featured_image
      ? trailData.featured_image
      : ""
  );
  const [otherMediaFiles, setOtherMediaFiles] = useState<any[]>(
    location?.state?.mode === "edit" && trailData?.other_images
      ? trailData.other_images
      : []
  );
  const [otherMediaPreviewShow, setOtherMediaPreviewShow] = useState<any[]>(
    location?.state?.mode === "edit" && trailData?.other_images
      ? trailData.other_images
      : []
  );
  const [imageLoader, setImageLoader] = useState<boolean>(false);
  const [otherImageLoader, setOtherImageLoader] = useState<boolean>(false);
  const [selectedTrailTypeOption, setSelectedTrailTypeOption] = useState<{
    label: string;
    value: string;
  } | null>(
    location?.state?.mode === "edit"
      ? { label: trailData?.trail_type, value: trailData?.trail_type }
      : null
  );
  const [selectedRouteTypeOption, setSelectedRouteTypeOption] = useState<{
    label: string;
    value: string;
  } | null>(
    location?.state?.mode === "edit"
      ? { label: trailData?.route_type, value: trailData?.route_type }
      : null
  );
  const [selectedDifficultyTypeOption, setSelectedDifficultyTypeOption] =
    useState<{ label: string; value: string } | null>(
      location?.state?.mode === "edit"
        ? { label: trailData?.difficulty, value: trailData?.difficulty }
        : null
    );

  const handleTrailTypeOptionChange = (selected: any) => {
    setSelectedTrailTypeOption(selected);
  };
  const handleRouteTypeOptionChange = (selected: any) => {
    setSelectedRouteTypeOption(selected);
  };
  const handleDifficultyTypeOptionChange = (selected: any) => {
    setSelectedDifficultyTypeOption(selected);
  };

  const trailTypeOptions = [
    { label: "Walk", value: "Walk" },
    { label: "Walk + Run", value: "Walk + Run" },
    { label: "Run", value: "Run" },
    { label: "Cycle", value: "Cycle" },
    { label: "Ride", value: "Ride" },
  ];
  const routeTypeOptions = [
    { label: "Loop", value: "Loop" },
    { label: "Out and back", value: "Out and back" },
    { label: "Point to point", value: "Point to point" },
  ];
  const difficultyTypeOptions = [
    { label: "Easy", value: "Easy" },
    { label: "Intermediate", value: "Intermediate" },
    { label: "Advanced", value: "Advanced" },
  ];

  const onSubmit = async (formData: any) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const formPayload = new FormData();

      // Always include basic fields
      formPayload.append("title", formData.title);
      formPayload.append("trail_type", formData.trailType.value);
      formPayload.append("route_type", formData.routeType.value);
      formPayload.append("difficulty", formData.difficultyType.value);
      formPayload.append("length", formData.length);
      formPayload.append("towns", formData.towns);
      formPayload.append("ascent", formData.totalAscent);
      formPayload.append("average_time_hours", formData.hours);
      formPayload.append("average_time_minutes", formData.minutes);
      formPayload.append("description", formData.description);
      formPayload.append("start_latitude", formData.gpxStartLat);
      formPayload.append("start_longitude", formData.gpxStartLng);

      // Handle file uploads for both new and edit modes
      if (isEditMode) {
        // Featured image
        if (editFeaturedImage) {
          if (!mediaFiles || mediaFiles.length === 0) {
            // If image was removed, send empty string
            formPayload.append("featured_image", "");
          } else if (mediaFiles[0]) {
            // If new image was uploaded
            const file = await base64ToFile(mediaFiles[0].data, fileName);
            const imageUrl = await uploadPhoto(file, "featuredImage");

            if (!imageUrl) {
              throw new Error("Failed to upload featured image");
            }
            formPayload.append("featured_image", fileName);
          }
        }

        // Other images
        if (editOtherImage) {
          // Always delete existing values first
          if (otherMediaPreviewShow.length === 0) {
            // Explicitly send empty array
            formPayload.append(
              "other_images",
              JSON.stringify(otherMediaPreviewShow)
            );
          } else {
            const existingImages = trailData?.other_images || [];

            // Handle new uploads if any
            if (otherMediaFiles.length > 0) {
              const files = await Promise.all(
                otherMediaFiles.map((media: any, index: number) => {
                  if (typeof media === "string") {
                    return null;
                  } else if (media.data) {
                    const originalFileName =
                      otherFileNames[index] || `default-${index}.jpg`; // Use default if missing
                    const uniqueFileName = `${Date.now()}-${index}-${originalFileName}`; // Use index for uniqueness
                    otherFileNames[index] = uniqueFileName; // Update the file name in the array
                    return base64ToFile(media.data, uniqueFileName);
                  } else {
                    console.error("Invalid media format:", media);
                    return null;
                  }
                })
              );
              // Filter out null values and existing files
              const validFiles = files.filter(
                (file): file is File => file !== null && file instanceof File
              );

              // Only process new files
              const newFiles = validFiles.filter(
                (file) => !existingImages.includes(file.name)
              );

              if (newFiles.length > 0) {
                const uploadResults = await batchUploadToCloudinary(
                  newFiles,
                  "otherImages"
                );

                if (uploadResults.some((result) => !result)) {
                  throw new Error("Failed to upload some images");
                }

                // Only add new filenames to the existing list
                const newFileNames = newFiles
                  .map((file) => file.name)
                  .filter(Boolean);
                setOtherFileNames((prev) => [...prev, ...newFileNames]); // Append new files to existing ones
              }
            }

            // Create an array of final image names in the correct order
            const allImages = otherMediaFiles
              .map((media: any, index: number) => {
                if (typeof media === "string") {
                  // If it's a string, it's an existing image
                  return media;
                } else if (media.data) {
                  // If it's a new file, use the corresponding name from otherFileNames
                  return otherFileNames[index];
                }
                return null;
              })
              .filter(Boolean);

            console.log("allImages :::", allImages);

            // Clear existing other_images from FormData
            formPayload.delete("other_images");
            // Add images to FormData only if there are any
            allImages.forEach((filename: any) => {
              formPayload.append("other_images", filename);
            });
          }
        }

        // GPX file
        if (formData.gpxFile instanceof File) {
          const formDataGpx = new FormData();
          formDataGpx.append("gpx_file", formData.gpxFile);

          try {
            const response = await uploadGpxFile(formData.gpxFile);
            if (response) {
              formPayload.append(
                "gpx_file",
                cleanFileName(formData.gpxFile.name)
              );
            } else {
              throw new Error("Failed to upload GPX file");
            }
          } catch (error) {
            console.error("Error uploading GPX file:", error);
            throw new Error("Failed to upload GPX file");
          }
        }
      } else {
        // Handle new trail file uploads (existing code)
        if (mediaFiles && mediaFiles[0]) {
          if (typeof mediaFiles[0] === "string") {
            // Already uploaded, just use the filename
            formPayload.append("featured_image", mediaFiles);
          } else if (mediaFiles[0].data) {
            // New file, upload it
            const file = await base64ToFile(mediaFiles[0].data, fileName);
            const uploadResult = await uploadPhoto(file, "featuredImage");
            if (!uploadResult) {
              throw new Error("Failed to upload featured image");
            }
            formPayload.append("featured_image", fileName);
          }
        }

        if (otherMediaFiles.length > 0 || otherFileNames.length > 0) {
          for (let i = 0; i < otherMediaFiles.length; i++) {
            const media = otherMediaFiles[i];
            const filename = otherFileNames[i];
            if (typeof media === "string") {
              // Already uploaded, just use the filename
              formPayload.append("other_images", media);
            } else if (media.data) {
              // New file, upload it
              const file = await base64ToFile(media.data, filename);
              const uploadResult = await uploadPhoto(file, "otherImages");
              if (!uploadResult) {
                throw new Error("Failed to upload some images");
              }
              formPayload.append("other_images", filename);
            }
          }
        }

        if (formData.gpxFile) {
          if (typeof formData.gpxFile === "string") {
            // Already uploaded, just use the filename
            formPayload.append("gpx_file", formData.gpxFile);
          } else if (formData.gpxFile instanceof File) {
            // New file, upload it
            try {
              const response = await uploadGpxFile(formData.gpxFile);
              if (response) {
                formPayload.append(
                  "gpx_file",
                  cleanFileName(formData.gpxFile.name)
                );
              } else {
                throw new Error("Failed to upload GPX file");
              }
            } catch (error) {
              console.error("Error uploading GPX file:", error);
              throw new Error("Failed to upload GPX file");
            }
          }
        }
      }

      let response;
      if (isEditMode) {
        // Remove empty strings from FormData EXCEPT for featured_image
        Array.from(formPayload.entries()).forEach(([key, value]) => {
          if (value === "" && key !== "featured_image") {
            formPayload.delete(key);
          }
        });

        response = await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}${TRAILS_EDIT}/${id}`,
          formPayload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              // 'Content-Type': 'application/json'
            },
          }
        );

        dispatch(
          showToast({
            show: true,
            message: response.data.message || "Trail updated successfully!",
            type: "success",
          })
        );
      } else {
        response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}${TRAILS_ADD}`,
          formPayload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              // 'Content-Type': 'application/json'
            },
          }
        );

        dispatch(
          showToast({
            show: true,
            message: response.data.message || "Trail added successfully!",
            type: "success",
          })
        );
      }

      if (location?.state?.suggestedTrailId) {
        try {
          await axios.patch(
            `${process.env.REACT_APP_API_BASE_URL}${SUGGESTED_TRAILS_STATUS}/${location.state.suggestedTrailId}`,
            {
              status: "Accepted",
              approved_trail_id: response.data.id,
              trail_data: location.state.trailData.created_at,
              // Use the ID of the newly created trail
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
          // Optionally show a toast for success
        } catch (error: any) {
          dispatch(
            showToast({
              show: true,
              message:
                error.response?.data?.message ||
                "Failed to update suggested trail status",
              type: "error",
            })
          );
        }
      }

      // const trailId = isEditMode ? id : response.data.id;

      navigate("/trails");
    } catch (error: any) {
      dispatch(
        showToast({
          show: true,
          message:
            error.response?.data?.message ||
            error.message ||
            "Failed to update trail",
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const addTrailForm = {
    featuredImage: {
      name: "featuredImage",
      validate: {
        required: {
          value: false,
        },
      },
    },
    otherThumbnailFile: {
      name: "otherThumbnailFile",
      validate: {
        required: {
          value: false,
        },
      },
    },
    title: {
      name: "title",
      validate: {
        required: {
          value: true,
        },
        maxLength: {
          value: 250,
          message: t("ONLY_250_CHARACTERS_ARE_ALLOWED"),
        },
      },
    },
    gpxStartLat: {
      name: "gpxStartLat",
      validate: {
        required: {
          value: false,
        },
        maxLength: {
          value: 250,
          message: "Max. 250 characters are allowed",
        },
      },
    },
    gpxStartLng: {
      name: "gpxStartLng",
      validate: {
        required: {
          value: false,
        },
        maxLength: {
          value: 250,
          message: "Max. 250 characters are allowed",
        },
      },
    },
    towns: {
      name: "towns",
      validate: {
        required: {
          value: true,
        },
        pattern: {
          value: Constant.REGEX.TOWNS,
          message: t("ENTER_VALID_TOWN_NAME"),
        },
      },
    },
    description: {
      name: "description",
      validate: {
        required: {
          value: true,
        },
        validate: {
          noEmoji: (value: string) =>
            (value && !value.match(Constant.REGEX.EMOJI)) ||
            t("EMOJIS_ARE_NOT_ALLOWED_IN_THE_DESCRIPTION"),
        },
      },
    },
    length: {
      name: "length",
      validate: {
        required: {
          value: true,
        },
        // pattern: {
        //   value: /^\d+(\.\d{1,2})?$/,
        //   message: t("ENTER_VALID_TITLE"),
        // },
      },
    },
    gpxFile: {
      name: "gpxFile",
      validate: {
        required: {
          value: true,
        },
      },
    },
    totalAscent: {
      name: "totalAscent",
      validate: {
        required: {
          value: true,
        },
      },
    },
    hours: {
      name: "hours",
      validate: {
        required: {
          value: false,
        },
      },
    },
    minutes: {
      name: "minutes",
      validate: {
        required: {
          value: true,
        },
      },
    },
    trailType: {
      name: "trailType",
    },
    routeType: {
      name: "routeType",
    },
    difficultyType: {
      name: "difficultyType",
    },
  };

  const uploadThumNailValid = {
    "image/png": [".png"],
    "image/jpg": [".jpg"],
    "image/jpeg": [".jpeg", ".jpg"],
  };

  const handleUploadThumnailFile = async (files: Blob[]) => {
    setEditFeaturedImage(true);
    if (files && files.length > 0) {
      setImageLoader(true);
      const updatedMediaFiles = [...mediaFiles];

      const processFile = (file: Blob) => {
        return new Promise<void>((resolve, reject) => {
          // Clean the filename before setting it
          const cleanedFileName = cleanFileName((file as File).name);
          setFileName(cleanedFileName);
          // setDbFeaturedImage(cleanedFileName);

          const fileSize = file.size;
          const reader = new FileReader();
          if (file.type.startsWith("image/")) {
            reader.onload = (event: any) => {
              const fileData = event.target.result;
              const image = new Image();

              image.onload = () => {
                const width = image.width;
                const height = image.height;
                const fileWithSize = {
                  data: fileData,
                  size: fileSize,
                  width: width,
                  height: height,
                };
                updatedMediaFiles.push(fileWithSize);
                resolve();
              };
              image.src = event.target.result;
            };
            reader.readAsDataURL(file);
          } else {
            resolve();
          }
        });
      };

      // Process all files
      const processingPromises = files.map((file) => processFile(file));
      await Promise.all(processingPromises);

      const finalMediaFiles = updatedMediaFiles.slice(0, 4);
      setImageLoader(false);
      setMediaPreviewShow(finalMediaFiles);
      setMediaFiles(finalMediaFiles);
    } else {
      setImageLoader(false);
    }
  };

  const handleUploadOtherThumnailFile = async (files: Blob[]) => {
    if (location?.state?.mode === "edit") {
      setEditOtherImage(true);
    }
    if (files && files.length > 0) {
      setOtherImageLoader(true);
      const updatedMediaFiles = [...otherMediaFiles];
      const newFileNames = [...otherFileNames];
      // const newDbOtherImages = [...dbOtherImages];

      const processFile = (file: Blob) => {
        return new Promise<void>((resolve, reject) => {
          // Clean the filename before adding it
          const cleanedFileName = cleanFileName((file as File).name);
          newFileNames.push(cleanedFileName);
          // newDbOtherImages.push(cleanedFileName);

          const fileSize = file.size;
          const reader = new FileReader();
          if (file.type.startsWith("image/")) {
            reader.onload = (event: any) => {
              const fileData = event.target.result;
              const image = new Image();

              image.onload = () => {
                const width = image.width;
                const height = image.height;
                const fileWithSize = {
                  data: fileData,
                  size: fileSize,
                  width: width,
                  height: height,
                };
                updatedMediaFiles.push(fileWithSize);
                resolve();
              };
              image.src = event.target.result;
            };
            reader.readAsDataURL(file);
          } else {
            resolve();
          }
        });
      };

      // Process all files
      const processingPromises = files.map((file) => processFile(file));
      await Promise.all(processingPromises);

      const finalMediaFiles = updatedMediaFiles.slice(0, 4);
      setOtherFileNames(newFileNames.slice(0, 4));
      // setDbOtherImages(newDbOtherImages.slice(0, 4));
      setOtherImageLoader(false);
      setOtherMediaPreviewShow(finalMediaFiles);
      setOtherMediaFiles(finalMediaFiles);
    } else {
      setOtherImageLoader(false);
    }
  };

  const removeMediaFile = (formMethod: any) => {
    setEditFeaturedImage(true);
    setMediaFiles("");
    setMediaPreviewShow("");
    formMethod.setValue("featuredImage", "", { shouldDirty: true });
    // setDbFeaturedImage('');
  };
  const removeOtherMediaFile = (index: number, formMethod: any) => {
    setEditOtherImage(true);
    const updatedMediaFiles = [...otherMediaFiles];
    const updatedMediaFilesURL = [...otherMediaPreviewShow];
    const updatedFileNames = [...otherFileNames];
    // const updatedDbOtherImages = [...dbOtherImages];

    updatedMediaFiles.splice(index, 1);
    updatedMediaFilesURL.splice(index, 1);
    updatedFileNames.splice(index, 1);
    // updatedDbOtherImages.splice(index, 1);

    setOtherMediaFiles(updatedMediaFiles);
    setOtherMediaPreviewShow(updatedMediaFilesURL);
    setOtherFileNames(updatedFileNames);
    // setDbOtherImages(updatedDbOtherImages);

    // formMethod.setValue('otherThumbnailFile', updatedDbOtherImages);
    // formMethod.setValue('otherFileNames', updatedFileNames);
  };

  // Convert trailData values to the format expected by the form
  const getInitialFormData = () => {
    if (location?.state?.mode === "edit") {
      return {
        featuredImage: trailData?.featured_image || "",
        title: trailData?.title || "",
        trailType: trailData?.trail_type
          ? {
              value: trailData.trail_type,
              label: trailData.trail_type,
            }
          : null,
        routeType: trailData?.route_type
          ? {
              value: trailData.route_type,
              label: trailData.route_type,
            }
          : null,
        difficultyType: trailData?.difficulty
          ? {
              value: trailData.difficulty,
              label: trailData.difficulty,
            }
          : null,
        length: trailData?.length || "",
        towns: trailData?.towns || "",
        totalAscent: trailData?.ascent || "",
        hours: trailData?.average_time_hours || "0",
        minutes: trailData?.average_time_minutes || "",
        gpxFile: trailData?.gpx_file || "",
        gpxStartLat: trailData?.start_latitude || trailData?.gpxStartLat || "",
        gpxStartLng: trailData?.start_longitude || trailData?.gpxStartLng || "",
        description: trailData?.description || "",
        otherFileNames: trailData?.other_images || [],
        otherThumbnailFile: trailData?.other_images || [],
      };
    }

    // Default values for add mode
    return {
      featuredImage: "",
      title: "",
      trailType: null,
      routeType: null,
      difficultyType: null,
      length: "",
      towns: "",
      totalAscent: "",
      hours: "0",
      minutes: "",
      gpxFile: "",
      gpxStartLat: "",
      gpxStartLng: "",
      description: "",
      otherFileNames: [],
      otherThumbnailFile: [],
    };
  };
  console.log("trailData?.gpx_file", trailData?.gpx_file);

  const resetAllValues = (formMethod: any) => {
    // Reset all state variables
    setMediaFiles("");
    setMediaPreviewShow("");
    setOtherMediaFiles([]);
    setOtherMediaPreviewShow([]);
    setFileName("");
    setOtherFileNames([]);
    setWordCount(0);
    setSelectedTrailTypeOption(null);
    setSelectedRouteTypeOption(null);
    setSelectedDifficultyTypeOption(null);
    setLoading(false);

    // Reset form fields
    formMethod.reset({
      featuredImage: "",
      title: "",
      trailType: null,
      routeType: null,
      difficultyType: null,
      length: "",
      towns: "",
      totalAscent: "",
      hours: "0",
      minutes: "",
      gpxFile: "",
      gpxStartLat: "",
      gpxStartLng: "",
      description: "",
      otherFileNames: [],
      otherThumbnailFile: [],
    });
  };

  const formMethodRef = useRef<any>(null);

  useEffect(() => {
    if (!location?.state?.mode && formMethodRef.current) {
      resetAllValues(formMethodRef.current);
    }
  }, [location?.state?.mode]);

  return (
    <>
      <Helmet>
        <title> Add New Trail | Town of 1000 Trails Admin Panel</title>
        <meta
          name="description"
          content="Add a new trail to the apps, including all trail information, visuals, and more."
        />
      </Helmet>
      <div className="main-container container addTrail-container">
        {location?.state?.mode === "edit" && (
          <div className="pageTopbar mb-4">
            <div className="leftPart d-flex">
              <CustomButton
                type="button"
                className="btn btn-transparent backBtn me-2"
                onClick={() => {
                  navigate(-1);
                  setMediaFiles("");
                  setMediaPreviewShow("");
                  setOtherMediaFiles([]);
                  setOtherMediaPreviewShow([]);
                }}
                title={t("BACK")}
                icon={<span className="icon icon-arrow-left me-2"></span>}
              />
              <h3 className="mb-0 d-flex align-items-center">
                {t("EDIT_TRAIL")}
              </h3>
            </div>
          </div>
        )}

        <HookForm defaultForm={getInitialFormData()} onSubmit={onSubmit}>
          {(formMethod) => {
            formMethodRef.current = formMethod;
            console.log(formMethod.getValues());
            console.log(
              "!formMethod.watch('gpxFile')",
              formMethod.watch("gpxFile")?.name?.toLowerCase().endsWith(".gpx")
            );

            console.log(
              formMethod.formState.isValid,
              formMethod.formState.isDirty
            );
            return (
              <>
                <div className="mb-5 row">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="row mb-4">
                      <div className="leftLabel col-4">
                        <Label className="lable">{t("FEATURED_IMAGE")}</Label>
                      </div>
                      <div className="rightField col-8">
                        <div
                          className={
                            mediaPreviewShow?.length > 0
                              ? "image-part imageRevert mb-0"
                              : "image-part mb-0"
                          }
                        >
                          <Controller
                            name={addTrailForm.featuredImage.name}
                            rules={{
                              required: {
                                value: false,
                                message: t("THUMBNAIL_FILE_IS_REQUIRED"),
                              },
                            }}
                            control={formMethod.control}
                            render={({ field: { onChange, value } }) => (
                              <>
                                {mediaPreviewShow && (
                                  <div className="iconWrapper">
                                    <img
                                      className="uploaded"
                                      src={
                                        typeof mediaPreviewShow === "string"
                                          ? getCloudinaryFeaturedImageUrl(
                                              mediaPreviewShow
                                            )
                                          : mediaPreviewShow[0]?.data
                                      }
                                      alt="preview"
                                    />
                                    <button
                                      type="button"
                                      disabled={loading}
                                      className={
                                        loading
                                          ? "disabled removeBtn text-danger text-decoration-underline"
                                          : "removeBtn text-danger text-decoration-underline"
                                      }
                                      onClick={() =>
                                        removeMediaFile(formMethod)
                                      }
                                    >
                                      {t("REMOVE")}
                                    </button>
                                  </div>
                                )}

                                {!mediaPreviewShow && (
                                  <FileUpload
                                    onDrop={async (acceptedFiles) => {
                                      const validFileTypes =
                                        Object.keys(uploadThumNailValid);
                                      const validFiles = acceptedFiles.filter(
                                        (file) =>
                                          validFileTypes.includes(file.type)
                                      );

                                      if (validFiles.length > 0) {
                                        setImageLoader(true);
                                        handleUploadThumnailFile(validFiles);
                                      }

                                      onChange({
                                        acceptedFiles,
                                      });
                                    }}
                                    disabled={loading}
                                    accept={uploadThumNailValid}
                                    multiple={false}
                                    maxFiles={1}
                                    triggerOpen={triggerRef}
                                  >
                                    {imageLoader ? (
                                      <div className="progress-wrapper">
                                        <div className="progress">
                                          <div className="progress-value"></div>
                                        </div>
                                        <p>{t("UPLOADING")}</p>
                                      </div>
                                    ) : (
                                      <div className="dropZoneWrapper">
                                        <i className="icon icon-plus-lg"></i>
                                        <span>{t("UPLOAD")}</span>
                                      </div>
                                    )}
                                  </FileUpload>
                                )}
                              </>
                            )}
                          />
                        </div>
                        <span className="garyLabel">
                          {t(
                            "SUPPORTED_FORMATS_ARE_JPEG_OR_PNG_WITH_A_RECOMMENDED_4_3_IMAGE_RATIO"
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="leftLabel col-4">
                        <Label className="lable">{t("OTHER_IMAGES")}</Label>
                      </div>
                      <div className="rightField col-8">
                        <div
                          className={
                            otherMediaPreviewShow?.length > 0
                              ? "image-part imageRevert mb-0"
                              : "image-part mb-0"
                          }
                        >
                          <Controller
                            name={addTrailForm.otherThumbnailFile.name}
                            rules={{
                              required: {
                                value: false,
                                message: t("THUMBNAIL_FILE_IS_REQUIRED"),
                              },
                            }}
                            control={formMethod.control}
                            render={({ field: { onChange, value } }) => (
                              <>
                                {otherMediaPreviewShow?.length !== 0 && (
                                  <>
                                    {otherMediaPreviewShow?.map(
                                      (item: any, index: number) => (
                                        <>
                                          <div className="iconWrapper">
                                            <img
                                              className="uploaded"
                                              src={
                                                typeof item === "string"
                                                  ? getCloudinaryOtherImageUrl(
                                                      item
                                                    )
                                                  : item?.data
                                              }
                                              alt="preview"
                                            />
                                            <button
                                              type="button"
                                              disabled={loading}
                                              className={
                                                loading
                                                  ? "disabled removeBtn text-danger text-decoration-underline"
                                                  : "removeBtn text-danger text-decoration-underline"
                                              }
                                              onClick={() =>
                                                removeOtherMediaFile(
                                                  index,
                                                  formMethod
                                                )
                                              }
                                            >
                                              {t("REMOVE")}
                                            </button>
                                          </div>
                                        </>
                                      )
                                    )}
                                  </>
                                )}
                                {otherMediaPreviewShow?.length < 4 && (
                                  <FileUpload
                                    onDrop={async (acceptedFiles) => {
                                      const validFileTypes =
                                        Object.keys(uploadThumNailValid);
                                      const validFiles = acceptedFiles.filter(
                                        (file) =>
                                          validFileTypes.includes(file.type)
                                      );

                                      if (validFiles.length > 0) {
                                        setOtherImageLoader(true);
                                        handleUploadOtherThumnailFile(
                                          validFiles
                                        );
                                      }

                                      onChange({
                                        acceptedFiles,
                                      });
                                    }}
                                    accept={uploadThumNailValid}
                                    multiple={true}
                                    disabled={loading}
                                    // maxFiles={5}
                                    triggerOpen={triggerRef}
                                  >
                                    {otherImageLoader ? (
                                      <div className="progress-wrapper">
                                        <div className="progress">
                                          <div className="progress-value"></div>
                                        </div>
                                        <p>{t("UPLOADING")}</p>
                                      </div>
                                    ) : (
                                      <>
                                        {otherMediaPreviewShow?.length < 4 && (
                                          <div className="dropZoneWrapper">
                                            <i className="icon icon-plus-lg"></i>
                                            <span>{t("UPLOAD")}</span>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </FileUpload>
                                )}
                              </>
                            )}
                          />
                        </div>
                        <span className="garyLabel">
                          {t(
                            "SUPPORTED_FORMATS_ARE_JPEG_OR_PNG_WITH_A_RECOMMENDED_4_3_IMAGE_RATIO_ALLOWING_UP_TO_A_MAXIMUM_OF_4_IMAGES"
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="leftLabel col-4">
                        <Label className="lable">{t("TITLE")}</Label>
                        <span className="redStar mx-2">*</span>
                      </div>
                      <div className="rightField col-8">
                        <div className="texFeildWrapper mb-3">
                          <TextField
                            formMethod={formMethod}
                            rules={addTrailForm.title.validate}
                            name={addTrailForm.title.name}
                            errors={formMethod?.formState.errors}
                            autoFocus={false}
                            disabled={loading}
                            required={true}
                            // onKeyDown={(e:any)=>{
                            //   if (e.key === " ") {
                            //     e.preventDefault(); // Prevent space characters for email input
                            //   }
                            // }}
                            handleBlur={(e: any) => {
                              const trimmedValue = e.target.value.trim();
                              formMethod.setValue(
                                addTrailForm.title.name,
                                trimmedValue,
                                { shouldValidate: true }
                              ); // Trim spaces and trigger validation
                            }}
                            type="text"
                            placeholder={t("ENTER_TITLE")}
                            onKeyDown={(e: React.KeyboardEvent) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission on enter
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="leftLabel col-4">
                        <Label className="lable">{t("TRAIL_TYPE")}</Label>
                        <span className="redStar mx-2">*</span>
                      </div>
                      <div className="rightField col-8">
                        <div className="texFeildWrapper mb-3">
                          <Controller
                            name={addTrailForm.trailType.name}
                            rules={{
                              required: {
                                value: true,
                                message: "",
                              },
                            }}
                            control={formMethod.control}
                            defaultValue={selectedTrailTypeOption}
                            render={({ field }) => (
                              <CustomSelect
                                value={selectedTrailTypeOption}
                                onChange={(option: any) => {
                                  handleTrailTypeOptionChange(option);
                                  field.onChange(option);
                                }}
                                closeMenuOnSelect={true}
                                placeholder={t("SELECT_TRAIL_TYPE")}
                                isClearable
                                isDisabled={loading}
                                options={trailTypeOptions}
                                isSearchable={false}
                                hideSelectedOptions={false}
                                className=""
                                classNamePrefix="react-select"
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="leftLabel col-4">
                        <Label className="lable">{t("ROUTE_TYPE")}</Label>
                        <span className="redStar mx-2">*</span>
                      </div>
                      <div className="rightField col-8">
                        <div className="texFeildWrapper mb-3">
                          <Controller
                            name={addTrailForm.routeType.name}
                            rules={{
                              required: {
                                value: true,
                                message: "",
                              },
                            }}
                            control={formMethod.control}
                            defaultValue={selectedRouteTypeOption}
                            render={({ field }) => (
                              <CustomSelect
                                value={selectedRouteTypeOption}
                                onChange={(option: any) => {
                                  handleRouteTypeOptionChange(option);
                                  field.onChange(option);
                                }}
                                closeMenuOnSelect={true}
                                placeholder={t("SELECT_ROUTE_TYPE")}
                                isClearable
                                options={routeTypeOptions}
                                isSearchable={false}
                                isDisabled={loading}
                                hideSelectedOptions={false}
                                className=""
                                classNamePrefix="react-select"
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="leftLabel col-4">
                        <Label className="lable">{t("DIFFICULTY_TYPE")}</Label>
                        <span className="redStar mx-2">*</span>
                      </div>
                      <div className="rightField col-8">
                        <div className="texFeildWrapper mb-3">
                          <Controller
                            name={addTrailForm.difficultyType.name}
                            rules={{
                              required: {
                                value: true,
                                message: "",
                              },
                            }}
                            control={formMethod.control}
                            defaultValue={selectedDifficultyTypeOption}
                            render={({ field }) => (
                              <CustomSelect
                                value={selectedDifficultyTypeOption}
                                onChange={(option: any) => {
                                  handleDifficultyTypeOptionChange(option);
                                  field.onChange(option);
                                }}
                                closeMenuOnSelect={true}
                                placeholder={t("SELECT_DIFFICULTY_TYPE")}
                                isClearable
                                isDisabled={loading}
                                options={difficultyTypeOptions}
                                isSearchable={false}
                                hideSelectedOptions={false}
                                className=""
                                classNamePrefix="react-select"
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="row mb-3">
                      <div className="leftLabel col-4">
                        <Label className="lable">{t("LENGTH")}</Label>
                        <span className="redStar mx-2">*</span>
                      </div>
                      <div className="rightField col-8">
                        <div className="texFeildWrapper mb-3">
                          <TextField
                            formMethod={formMethod}
                            rules={addTrailForm.length.validate}
                            name={addTrailForm.length.name}
                            errors={formMethod?.formState.errors}
                            autoFocus={false}
                            required={true}
                            disabled={loading}
                            type="number"
                            leftLabel={true}
                            placeholder={t("00")}
                            twoDecimal={true}
                            leftLabelText={t("MILES")}
                            onKeyDown={(e: React.KeyboardEvent) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission on enter
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="leftLabel col-4">
                        <Label className="lable">{t("TOWNS")}</Label>
                        <span className="redStar mx-2">*</span>
                      </div>
                      <div className="rightField col-8">
                        <div className="texFeildWrapper mb-3">
                          <TextField
                            formMethod={formMethod}
                            rules={addTrailForm.towns.validate}
                            name={addTrailForm.towns.name}
                            errors={formMethod?.formState.errors}
                            autoFocus={false}
                            required={true}
                            disabled={loading}
                            type="text"
                            placeholder={t("ENTER_TOWNS")}
                            onKeyDown={(e: React.KeyboardEvent) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission on enter
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="leftLabel col-4">
                        <Label className="lable">{t("TOTAL_ASCENT")}</Label>
                        <span className="redStar mx-2">*</span>
                      </div>
                      <div className="rightField col-8">
                        <div className="texFeildWrapper mb-3">
                          <TextField
                            formMethod={formMethod}
                            rules={addTrailForm.totalAscent.validate}
                            name={addTrailForm.totalAscent.name}
                            errors={formMethod?.formState.errors}
                            autoFocus={false}
                            required={true}
                            type="number"
                            leftLabel={true}
                            totalAscent={true}
                            disabled={loading}
                            placeholder={t("00")}
                            threeDecimal={true}
                            maxWords={10}
                            leftLabelText={t("METRES")}
                            onKeyDown={(e: React.KeyboardEvent) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission on enter
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="leftLabel col-4">
                        <Label className="lable">{t("AVERAGE_TIME")}</Label>
                        <span className="redStar mx-2">*</span>
                      </div>
                      <div className="rightField col-8">
                        <div className="row">
                          <div className="texFeildWrapper mb-3 col-6">
                            <TextField
                              formMethod={formMethod}
                              rules={addTrailForm.hours.validate}
                              name={addTrailForm.hours.name}
                              errors={formMethod?.formState.errors}
                              autoFocus={false}
                              required={false}
                              type="number"
                              disabled={loading}
                              leftLabel={true}
                              hours={true}
                              placeholder={t("00")}
                              decimalNotAllowed={true}
                              leftLabelText={t("HOURS")}
                              onKeyDown={(e: React.KeyboardEvent) => {
                                if (e.key === "Enter") {
                                  e.preventDefault(); // Prevent form submission on enter
                                }
                              }}
                            />
                          </div>
                          <div className="texFeildWrapper mb-3 col-6">
                            <TextField
                              formMethod={formMethod}
                              rules={addTrailForm.minutes.validate}
                              name={addTrailForm.minutes.name}
                              errors={formMethod?.formState.errors}
                              autoFocus={false}
                              required={true}
                              type="number"
                              leftLabel={true}
                              disabled={loading}
                              placeholder={t("00")}
                              max={59}
                              minutes={true}
                              decimalNotAllowed={true}
                              leftLabelText={t("MINUTES")}
                              onKeyDown={(e: React.KeyboardEvent) => {
                                if (e.key === "Enter") {
                                  e.preventDefault(); // Prevent form submission on enter
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="leftLabel col-4">
                        <Label className="lable">{t("GPX_FILE")}</Label>
                        <span className="redStar mx-2">*</span>
                      </div>
                      <div className="rightField col-8">
                        {location?.state?.mode === "edit" &&
                        trailData?.gpx_file !== "" ? (
                          <div className="form-control d-flex align-items-center justify-content-between">
                            <span className="selectedFile">
                              {trailData?.gpx_file?.split("/")?.pop()}
                            </span>
                            <button
                              disabled={loading}
                              className="removeBtn text-danger text-decoration-underline"
                              onClick={() => {
                                trailData.gpx_file = "";
                                formMethod.setValue("gpxFile", "");
                                // Force re-render
                                setLoading(true);

                                setTimeout(() => {
                                  setLoading(false);
                                }, 1000);
                              }}
                            >
                              {t("REMOVE")}
                            </button>
                          </div>
                        ) : (
                          <>
                            <TextField
                              formMethod={formMethod}
                              rules={{
                                ...addTrailForm.gpxFile.validate,
                                required: {
                                  value: !trailData?.gpx_file,
                                  // message: t("GPX_FILE_IS_REQUIRED")
                                },
                              }}
                              name={addTrailForm.gpxFile.name}
                              errors={formMethod?.formState.errors}
                              autoFocus={false}
                              required={!trailData?.gpx_file}
                              disabled={loading}
                              type="file"
                              accept=".gpx"
                              // accept=".gpx,application/gpx+xml"
                              removeFileFunc={() => {
                                formMethod.setValue("gpxFile", undefined);
                              }}
                            />
                            <span className="garyLabel">
                              {t("SUPPORTED_FORMATS")} <b>GPX</b>
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="leftLabel col-4">
                        <Label className="lable">{t("GPX_START_LAT")}</Label>
                      </div>
                      <div className="rightField col-8">
                        <div className="texFeildWrapper mb-3">
                          <TextField
                            formMethod={formMethod}
                            rules={addTrailForm.gpxStartLat.validate}
                            name={addTrailForm.gpxStartLat.name}
                            errors={formMethod?.formState.errors}
                            autoFocus={false}
                            disabled={loading}
                            required={false}
                            type="text"
                            placeholder={t("ENTER_LATITUDE")}
                            onKeyDown={(e: React.KeyboardEvent) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission on enter
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="leftLabel col-4">
                        <Label className="lable">{t("GPX_START_LNG")}</Label>
                      </div>
                      <div className="rightField col-8">
                        <div className="texFeildWrapper mb-3">
                          <TextField
                            formMethod={formMethod}
                            rules={addTrailForm.gpxStartLng.validate}
                            name={addTrailForm.gpxStartLng.name}
                            errors={formMethod?.formState.errors}
                            autoFocus={false}
                            disabled={loading}
                            required={false}
                            type="text"
                            placeholder={t("ENTER_LONGITUDE")}
                            onKeyDown={(e: React.KeyboardEvent) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission on enter
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <div className="row">
                      <div className="leftLabel col-2">
                        <Label className="lable">{t("DESCRIPTION")}</Label>
                        <span className="redStar mx-2">*</span>
                      </div>
                      <div className="rightField col-10">
                        <div className="texFeildWrapper textareaWrapper mb-3">
                          <TextField
                            formMethod={formMethod}
                            rules={addTrailForm.description.validate}
                            name={addTrailForm.description.name}
                            errors={formMethod?.formState.errors}
                            autoFocus={false}
                            textarea={true}
                            required={true}
                            disabled={loading}
                            maxWords={600}
                            wordCount={wordCount}
                            onChange={(e) => {
                              const words = e.target.value
                                .trim()
                                ?.split(/\s+/)
                                .filter((word) => word.length > 0);
                              setWordCount(words.length);
                              e.target.style.height = "auto";
                              e.target.style.height = `${e.target.scrollHeight}px`;
                            }}
                            type="textarea"
                            placeholder={t("ENTER_DESCRIPTION")}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="submitDiv">
                  <CustomButton
                    className="btn btn-danger text-white btn-lg text-center justify-content-center me-3"
                    type="submit"
                    loading={loading}
                    title={
                      location?.state?.mode === "edit"
                        ? t("UPDATE")
                        : t("SUBMIT")
                    }
                    disabled={
                      location?.state?.mode === "edit"
                        ? !(
                            formMethod?.formState.isDirty ||
                            editFeaturedImage ||
                            editOtherImage ||
                            formMethod
                              .watch("gpxFile")
                              ?.name?.toLowerCase()
                              .endsWith(".gpx") ||
                            formMethod
                              .watch("gpxFile")
                              ?.name?.toLowerCase()
                              .endsWith(".gpx")
                          ) ||
                          wordCount > 600 ||
                          !formMethod.formState.isValid // Add general form validation
                        : !formMethod?.formState.isValid ||
                          !formMethod.watch("gpxFile") ||
                          wordCount > 600 ||
                          !formMethod
                            .watch("gpxFile")
                            ?.name?.toLowerCase()
                            .endsWith(".gpx")
                    }
                  />
                  <CustomButton
                    className="btn btn-transparent"
                    title={t("CANCEL")}
                    onClick={() => {
                      if (location?.state?.mode === "edit") {
                        navigate(`/trails/trail-detail/${trailData?.id}`, {
                          state: { trailData: trailData }, // Pass the trail data in navigation state
                        });
                      } else {
                        navigate("/trails");
                      }
                    }}
                  />
                </div>
              </>
            );
          }}
        </HookForm>
      </div>
    </>
  );
};

export default AddTrail;
